import React, { useMemo, useState } from 'react';
import './FabricInquiryNewDetails.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { createB2BAPI } from '../../../api/Interceptor';
import { useNavigate } from 'react-router-dom';
import notify from '../../../utils/Notification';
import { Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

const initialState = {
    endUse: '',
    season: '',
    fabricType: '',
    fiberComposition: '',
    weightMin: '',
    weightMax: '',
    finishPerformance: '',
    priceMin: '',
    priceMax: '',
    expectedOrderAmount: '',
    note: '',
    isProgress: true
}

const FabricInquiryNewDetails = () => {
    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const [formData, setFormData] = useState(initialState);
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [text, setText] = useState('');
    const [isChecked, setIsChecked] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImageFile(file);
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setImagePreview(previewUrl);
        }
    };

    const handleTextChange = (e) => {
        setText(e.target.value);
    };

    const handleCheckboxClick = () => {
        setIsChecked((prevChecked) => !prevChecked);
    };
const validateFiberComposition = (input) => {
    if (!input) return false;

    if (!input.includes('/')) return true;

    const parts = input.split('/');

    let total = 0;

    for (let part of parts) {
        part = part.trim();

        const match = part.match(/^([a-zA-Z\s]+)\s*(\d{1,3})%$/);

        if (!match) return false;

        const percent = Number(match[2]);

        if (percent < 0 || percent > 100) return false;

        total += percent;
    }

    return total === 100;
};
    const handleSubmit = async (e) => {
        e.preventDefault();
        const percentages = formData.fiberComposition.match(/\d+/g);
    if (!imageFile) {
        return notify({
            title: 'Validation Error',
            message: 'Please upload a reference image before submitting the inquiry.',
            error: true
        });
    }

    if (!validateFiberComposition(formData.fiberComposition)) {
        return notify({
            title: 'Validation Error',
            message:
                'Fiber Composition must be in format like "Cotton 70% / Polyester 30%" and total must equal 100%',
            error: true
        });
    }

        const formDataToSubmit = new FormData();

        formDataToSubmit.append(
            "fabricInquiry",
            new Blob([JSON.stringify(formData)], {
                type: "application/json"
            })
        );

        if (imageFile) {
            formDataToSubmit.append('image', imageFile);
        }

        try {
      const res = await B2B_API.post('fabricInquiry', {
    body: formDataToSubmit
}).json();

            notify({
                title: 'Success',
                message: 'Fabric Inquiry Submitted Successfully',
                success: true
            });

            setFormData(initialState);
            setImageFile(null);
            setImagePreview('');
            setText('');
        } catch (error) {
            notify({
                title: 'Error',
                message: error.message || 'Failed to submit Fabric Inquiry',
                error: true
            });

            console.error('Error submitting the form:', error);
        }
    };

    const handleWheel = (e) => {
        e.preventDefault();
    };

    return (
        <div className="view-create-fabric-inquiry router-view-container">
            <div className="content">     
                <div className="page-title" style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span className="text">
                        Fabric Inquiry <i className="icon far fa-search"></i>
                    </span>
                        <Button
                                color='#8BC54F'
                                onClick={() => navigate("/fabricInquiries")}
                                leftSection={<IconArrowLeft stroke={2} />}
                              >
                                Back
                              </Button>
                </div>
                <div className="flex-layout">
                    <div className="inquiry-text-container">
                        <div className="inquiry-description">
                            <div className="description-title">How does this work?</div>
                            <div className="description-content">
                                After you submit your inquiry, our 👨🏻‍💻 <b>FABRIC SPECIALISTS</b> use your information to curate a shortlist of fabrics that will best fit your sourcing needs.
                                <span>
                                    The more detailed your response is, the better we will be able to find fabrics that meet your exact needs.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="form-container">
                        <div className="inquiry-warning">
                            <i className="fas fa-exclamation-triangle"></i>
                            <div className="warning">
                                Please submit an inquiry for <b>a single piece of garment or fabric.</b>
                                If multiple garments or fabrics are described, we will base our recommendations on the first item.
                            </div>

                        </div>
                        <form className="form" onSubmit={handleSubmit}>
                            <div className="form-control required">
                                <label>End Use</label>
                                <input
                                    name='endUse'
                                    placeholder="Dress"
                                    className="required-but-empty"
                                    value={formData.endUse}
                                    onChange={handleChange}
                                    type='texy'
                                    required
                                />
                            </div>
                            <div className="form-control">
                                <label>Season</label>
                                <select name='season' value={formData.season} onChange={handleChange} required>
                                    <option disabled=""></option>
                                    <option value="S/S">S/S</option>
                                    <option value="F/W">F/W</option>
                                    <option value="Seasonless">Seasonless</option>
                                </select>
                            </div>
                            <div className="form-control required">
                                <label>Fabric Type</label>
                                <input
                                    name='fabricType'
                                    placeholder="Single Jersey, Denim or French terry etc."
                                    className="required-but-empty"
                                    value={formData.fabricType}
                                    onChange={handleChange}
                                    type='text'
                                    required
                                />
                            </div>
                            <div className="form-control required">
                                <label>Fiber Composition</label>
                                <input
                                    name='fiberComposition'
                                    placeholder="Linen 70% / Cotton 30%"
                                    value={formData.fiberComposition}
                                    onChange={handleChange}
                                    className="required-but-empty"
                                    type='text'
                                    required
                                />
                            </div>
                            <div className="form-control required">
                                <label>Weight</label>
                                <div className="description">
                                    Entering either the season or weight range helps us narrow down the fabrics that are appropriate for your use
                                </div>
                                <div className="flex-row items-center">
                                    <input
                                        type="number"
                                        name="weightMin"
                                        placeholder="min"
                                        inputMode="numeric"
                                        className="required-but-empty"
                                        value={formData.weightMin}
                                        onChange={handleChange}
                                        required
                                    />
                                    <div className="tofrom flex-wrap">-</div>
                                    <input
                                        type="number"
                                        name="weightMax"
                                        placeholder="max"
                                        inputMode="numeric"
                                        className="required-but-empty"
                                        value={formData.weightMax}
                                        onChange={handleChange}
                                        required
                                    />
                                    <div className="suffix">gsm</div>
                                </div>
                            </div>
                            <div className="form-control">
                                <label>Finish or Performance</label>
                                <input
                                    name="finishPerformance"
                                    placeholder="Brushed"
                                    value={formData.finishPerformance}
                                    onChange={handleChange}
                                    required
                                />
                                <div className="notice">e.g. Brushed or pleated, foil etc.</div>
                            </div>
                            <div className="form-control required">
                                <label>Target Price</label>
                                <div className="flex-row items-center">
                                    <input
                                        type="number"
                                        name="priceMin"
                                        placeholder="min"
                                        inputMode="numeric"
                                        className="required-but-empty"
                                        value={formData.priceMin}
                                        onChange={handleChange}
                                        required
                                    />
                                    <div className="tofrom flex-wrap">-</div>
                                    <input
                                        type="number"
                                        name="priceMax"
                                        placeholder="max"
                                        inputMode="numeric"
                                        className="required-but-empty"
                                        value={formData.priceMax}
                                        onChange={handleChange}
                                        required
                                    />
                                    <div className="suffix">$</div>
                                </div>
                            </div>
                            <div className="form-control">
                                <label>Expected Order Amount</label>
                                <div className="flex-row items-center">
                                    <input
                                        type="number"
                                        name="expectedOrderAmount"
                                        inputMode="numeric"
                                        value={formData.expectedOrderAmount}
                                        onWheel={handleWheel}
                                        onChange={handleChange}
                                    />
                                    <div className="suffix">yards</div>
                                </div>
                            </div>
                            <div className="form-control">
                                <label>Reference Images</label>
                                <div className="description">
                                    Please share any fabric/inspirational images that we can reference.
                                </div>
                                <button type="button" className="btninqury flex-fill btninqury-file" onClick={() => document.getElementById('imageFileInput').click()} style={{ position: 'relative', cursor: 'pointer' }}>
                                    <img src="https://swatchon.com/img/ic-add-image-purple.8fdce5c1.svg" className="m-r-16" />
                                    Upload Image
                                    <input id="imageFileInput" type="file" className="overlay cursor-pointer" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} />
                                </button>

                                {imagePreview && (
                                    <div className="reference-images">
                                        <div className="reference-image">
                                            <div className="image-container">
                                                <img
                                                    className="app-img cover overlay"
                                                    src={imagePreview}
                                                    alt="Uploaded Reference"
                                                    loading="lazy"
                                                />
                                                <div className="dark overlay">
                                                </div>
                                                <div className="remover" >
                                                    <FontAwesomeIcon
                                                        icon={faCircleXmark}
                                                        onClick={() => {
                                                            setImagePreview('');
                                                            setImageFile(null);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="form-control m-b-4">
                                                    <label className="flex-row items-center">
                                                        <span className="flex-wrap">'Where did you find this image?'</span>
                                                    </label>
                                                    <div className="input-and-error show-length">
                                                        <textarea
                                                            placeholder="Being as descriptive as possible about the source of this image can help us narrow down our fabric selection"
                                                            className=""
                                                            maxLength="85"
                                                            value={text}
                                                            onChange={handleTextChange}
                                                        />
                                                        <div className="length">{text.length} / 85</div>
                                                    </div>
                                                </div>
                                                <div className="notice">e.g. website link, brand, etc.</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="form-control">
                                <label className="flex-row items-center">
                                    <span className="flex-wrap">Note</span>
                                </label>
                                <div className="input-and-error show-length">
                                    <textarea
                                        name="note"
                                        placeholder="Share any information that will help us find the fabrics you need."
                                        value={formData.note}
                                        onChange={handleChange}
                                        maxLength="1000"
                                    />
                                    <div className="length">{formData.note.length} / 1000</div>
                                </div>
                            </div>
                            <div className="checkbox-container" onClick={handleCheckboxClick}>
                                <div className={`app-checkbox ${isChecked ? 'checked' : ''}`}>
                                    <div className="circle">{isChecked && '✔'}</div>
                                </div>
                                I confirm that this fabric inquiry is related to a single piece of garment fabric.
                            </div>
                            <button
                                type="submit"
                                disabled={!isChecked}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    borderRadius: "5px",
                                    cursor: !isChecked ? "not-allowed" : "pointer",
                                    backgroundColor: !isChecked ? "gray" : "#8BC53F",
                                }}
                                className="btninqury btninqury-primary btninqury-submit">
                                Submit Inquiry
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FabricInquiryNewDetails;
